const safeSessionStorage = typeof sessionStorage !== 'undefined' ? sessionStorage : null;

const DEFAULT_TIMEOUT = 5000;
const INTERVAL = 100;

export const waitForSessionStorageValue = async (
    key: string,
    valueCondition: (value?: string | null) => boolean = (value) => !!value,
    { timeout = DEFAULT_TIMEOUT }: { timeout?: number } = {}
) =>
    new Promise((resolve, reject) => {
        const intervalId = setInterval(() => {
            if (valueCondition(safeSessionStorage?.getItem(key))) {
                resolve(safeSessionStorage?.getItem(key));
                clearInterval(intervalId);
            }
        }, INTERVAL);

        setTimeout(() => {
            if (valueCondition(safeSessionStorage?.getItem(key))) {
                resolve(safeSessionStorage?.getItem(key));
            } else {
                reject(new Error(`Timed out waiting for sessionStorage value ${key}`));
            }
            clearInterval(intervalId);
        }, timeout);
    });
